
import getApiDataByContext from '~/utils/getApiDataByContext';
import headerComponent from '~/components/headerComponent.vue';
import { contentWrapper } from '@tidal/microservice-components';
import tidalButton from '@tidal/styles-button/src/components/tidal-button.vue';
import getErrorTranslationKey from '~/utils/getErrorTranslationKey';
import { getSubscriptionTypeName, isValidSubscriptionType } from '../../../../../api/utils/subscription.util';

export default {
    components: {
        contentWrapper,
        headerComponent,
        tidalButton,
    },
    asyncData: getApiDataByContext,
    data() {
        return {
            /** @type {OfferWeb.ClientSideUser | null} */
            user: null,
            loading: false,
            /** @type {import('@tidal/user-middleware').AppMode | null} */
            appMode: null,
            geo: '',
            title: '',
            subtitle: '',
            customPartnerLogoUrl: '',
            /** @type {OfferWeb.PartnerOrder | null} */
            order: null,
        };
    },
    computed: {
        /** @returns {string} */
        helloText() {
            return this.$t('partner.hey', { email: this.user?.email || this.user?.userName || '' });
        },
        /** @returns {string} */
        orderText() {
            const type = this.order && isValidSubscriptionType(this.order.subscriptionType) ?
                getSubscriptionTypeName(this.order.subscriptionType, this.$t.bind(this)) : '';
            return this.$t('partner.order', { type });
        },
    },
    beforeDestroy() {
        this.loading = false;
    },
    methods: {
        async makeOrder() {
            this.$toast.clear();

            if (this.loading) {
                return;
            }

            this.loading = true;

            const data = {
                order: this.order,
            };
            let response;

            try {
                response = await this.$axios.post('/api/partner/order', data);
            } catch (error) {
                this.loading = false;
                /** @type {import('axios').AxiosError<import('@tidal/user-models').ClientApiError>} */
                const apiError = error;

                this.$toast.error(this.$t(getErrorTranslationKey(apiError.response?.data.messageCode)));
                return;
            }

            window.location = response.data.redirect;
        },
    },
};
